"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _roundForPrecision = _interopRequireDefault(require("./roundForPrecision"));

var decimalToPercentageValue = function decimalToPercentageValue(decimalValue) {
  return (0, _roundForPrecision["default"])(decimalValue * 100);
};

var _default = decimalToPercentageValue;
exports["default"] = _default;